/* eslint-disable @typescript-eslint/no-unused-vars */
import { CheckboxInputAccessible } from '@components';
import { iReviewFormValues } from '@services/ReviewService';
import { Field, useFormikContext } from 'formik';
import { ReactElement, useEffect, useState } from 'react';

function ReviewStep14(): ReactElement {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { values, setFieldValue }: { values: iReviewFormValues; setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void } = useFormikContext<iReviewFormValues>();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState(false);
    const [declarationMsg, setDeclarationMsg] = useState(<div>Unpopulated</div>);
    const IndividualIR: ReactElement = (
      <div>
        <p>I understand that this is the only internal review for this infringement that I am able to submit under section 22(2) of the <i>Infringements Act 2006</i>.</p>
        <p>I declare that the information that I have supplied in this form, and any attachments to this form, are true and correct to the best of my knowledge.</p>
        <p>I understand that by making a false or misleading statement in support of this claim, I may be prosecuted.</p>
      </div>
    );
    const IndividualER: ReactElement = (
      <div>
        <p>I authorise Fines Victoria to disclose my personal information to the enforcement agencies that issued the fine(s), the Magistrates’ Court of Victoria and any person whose evidence I rely on in support of this application, and</p>
        <p>I understand that Fines Victoria may update its records with my contact details provided on this form, and that I may be contacted regarding my outstanding fines, and</p>
        <p>I declare that the information supplied in this form, and any attachments to this form, are true and correct to the best of my knowledge, and</p>
        <p>I understand that it is an offence under the <i>Fines Reform Act 2014</i> to intentionally provide false or misleading information in a written statement required by or under that Act. I understand that the offence carries a fine in excess of $1900.</p>
      </div>
    );
    const CompanyIR: ReactElement = (
      <div>
        <p>I am authorised to act on behalf of the company to submit this application.</p>
        <p>I understand that this is the only internal review for this infringement that the company may submit under  section 22(2) of the <i>Infringements Act 2006</i>.</p>
        <p>I declare that the information that I have supplied in this form, and any attachments to this form, are true and correct to the best of my knowledge.</p>
        <p>I understand that by making a false or misleading statement in support of this claim, I may be prosecuted.</p>
      </div>
    );
    const CompanyER: ReactElement = (
      <div>
        <p>I declare that I am authorised to act on behalf of the company named on the notice of final demand.</p>
        <p>I authorise Fines Victoria to release the company information and my personal information contained in this application to the enforcement agencies that issued the fine(s), the Magistrates’ Court of Victoria, and any person whose evidence is relied on in support of this application.</p>
        <p>I understand that Fines Victoria may update its records with the contact details provided on this form, and that the company may be contacted regarding its outstanding fines.</p>
        <p>I declare that the information that I have supplied on this form, and any attachments to this form, are true and correct to the best of my knowledge.</p>
        <p>I understand that it is an offence under the <i>Fines Reform Act 2014</i> to intentionally provide false or misleading information in a written statement required by or under that Act. I understand that the offence carries a fine in excess of $1900.</p>
      </div>
    );
    const ThirdPartyIR: ReactElement = (
      <div>
        <p>I am authorised to act on behalf of the fine holder and they are aware that I am making this application on their behalf.</p>
        <p> I understand that this is the only internal review for this infringement that I am able to submit under section 22(2) of the <i>Infringements Act 2006</i>.</p>
        <p>I declare that the information that I have supplied in this form, and any attachments to this form, are true and correct to the best of my knowledge.</p>
        <p>I understand that by making a false or misleading statement in support of this claim, I may be prosecuted.</p>
      </div>
    );
    const ThirdPartyER: ReactElement = (
      <div>
        <p>I declare that the fineholder is aware that I am making this application on their behalf, and I am authorised to act on their behalf.</p>
        <p>I have informed the applicant that:</p>
        <ul>
          <li>
            <p>their personal information may be disclosed to the enforcement agencies that issued the fine(s) and the Magistrates’ Court and any person whose evidence is relied on in support of this application, and</p>
          </li>
          <li>
            <p>Fines Victoria may update its records with their contact details provided on this form, and that they may be contacted regarding any outstanding fines.</p>
          </li>
        </ul>
        <p>I declare that the information that I have supplied on this form, and any attachments to this form, is true and correct to the best of my knowledge, and</p>
        <p>I understand that it is an offence under the <i>Fines Reform Act 2014</i> to intentionally provide false or misleading information in a written statement required by or under that Act. I understand that the offence carries a fine in excess of $1900.</p>
      </div>
    );

    useEffect(() => {
        if (values.isDebtorTypeIndividual) {
            if (values.isInternalReviewStage) {
                setDeclarationMsg(IndividualIR);
            }
            if (values.isEnforcementReviewStage) {
                setDeclarationMsg(IndividualER);
            }
        }
        if (values.isDebtorTypeCompany) {
            if (values.isInternalReviewStage) {
                setDeclarationMsg(CompanyIR);
            }
            if (values.isEnforcementReviewStage) {
                setDeclarationMsg(CompanyER);
            }
        }
        if (values.isThirdPartyAuthorised) {
            if (values.isInternalReviewStage) {
                setDeclarationMsg(ThirdPartyIR);
            }
            if (values.isEnforcementReviewStage) {
                setDeclarationMsg(ThirdPartyER);
            }
        }
      }, []);
    return (
      <>
        <div className="vfH2">Declaration</div>
        <div>{declarationMsg}</div>
        <Field
          name="ReviewConsentToDeclaration"
          component={CheckboxInputAccessible}
          title="I agree to the statements above"
        />
      </>
    );
}

export default ReviewStep14;
